module.exports = __webpack_public_path__ + "img/generic-two-type-parameters.08d9e283.jpg";